module.exports = __webpack_public_path__ + "img/slbtn1.045f9c27.png";